module.exports = require("@ember/test-waiters");